import { useSuspenseQuery } from "@tanstack/react-query";
import { actions } from "astro:actions";

export const useQuota = () => {
  const { data } = useSuspenseQuery({
    staleTime: Infinity,
    queryFn: actions.me.getQuota.orThrow,
    queryKey: ["quota"],
  });
  return data;
};
